import React from 'react';
import ReactDOM from 'react-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import App from './App';
import aname, { bname, myName } from './Comp';
import Calcapp from './Calcapp';
import Card from './Cards';
import Sdata from './Sdata';
import Appp from './Appp';
import Apppp from './Apppp';
import Slotmachine from './Slotmachine';
import State from './State';
import GetTime from './GetTime';
import GetTimeD from './GetTimeD';
import BG from './Bg';
import Forma from './Forma';
import Formb from './Formb';
import Formc from './Formc';
import Formd from './Formd';
import Todo from './Todo';
import Incdec from './Incdec';
import BasicTextFields from './Muicom';
import UrgeWithPleasureComponent from './countdown';
import Clockc from './Clockc';
import Todolistnew from './Todolistnew';
import Accordiann from './accordian/Accordian';
import Googlekeep from './googlekeep/Googlekeep';
import Contexta from './context/Context';
import Useeffecta from './Useeffect';
import Covida from './Covida';
import Pokemonapi from './Pokemonapi';
import Page from './route/Page';
import Todo2 from './todonew/todo';
import Todol from './todonew/todolocal';

// function ncard(val){
//   return(
//     <Card
//     imgsrc={val.imgsrc} 
//     title={val.title}  
//     text={val.text} 
//     link={val.link}  /> 
//   )
// }


ReactDOM.render(
  <>
    <div className='container'>
      <App />
      <ol>
        <li>Moobeen One</li>
        <li>{aname}</li>
        <li>{bname}</li>
        <li>{myName()}</li>
      </ol>
      <Calcapp />
      <h2>Components</h2>
      <div className='row'>

        <Card imgsrc="https://picsum.photos/id/237/200/300"
          title="Card title"
          text="Some quick example text to build on the card title and make up the bulk of the card's content."
          link="alpha.html" />

        <Card imgsrc="https://picsum.photos/id/227/200/300"
          title="Card title"
          text="Some quick example text to build on the card title and make up the bulk of the card's content."
          link="alpha.html" />

        <Card imgsrc="https://picsum.photos/id/247/200/300"
          title="Card title"
          text="Some quick example text to build on the card title and make up the bulk of the card's content."
          link="alpha.html" />

      </div>
      <hr />
      <h2>Array Com</h2>
      <div className='row'>

        <Card imgsrc={Sdata[0].imgsrc}
          title={Sdata[0].title}
          text={Sdata[0].text}
          link={Sdata[0].link} />

        <Card imgsrc={Sdata[1].imgsrc}
          title={Sdata[1].title}
          text={Sdata[1].text}
          link={Sdata[1].link} />

        <Card imgsrc={Sdata[2].imgsrc}
          title={Sdata[2].title}
          text={Sdata[2].text}
          link={Sdata[2].link} />

      </div>
      <hr>
      </hr>
      <h2>Map Fucntion</h2>
      <div className='row'>
        {/* {Sdata.map(function ncard(val){
  return(
    <Card
    imgsrc={val.imgsrc} 
    title={val.title}  
    text={val.text} 
    link={val.link}  /> 
  )
})} */}
        {/* Fat Arrow */}
        {Sdata.map((val, index) => {
          return (
            <Card
              key={val.id}
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}
              link={val.link} />
          )
        })}
      </div>
      {/* Appp Template */}
      <h2>If Else</h2>
      <Appp />
      {/* Apppp Template */}
      <h2>If Else Conditional Rendering | Ternary Operator</h2>
      <Apppp />
      <hr />
      <center><Slotmachine /></center>
      <hr />
      <center><State /></center>
      <hr />
      <center><GetTime /></center>
      <hr />
      <center><GetTimeD /></center>
      <hr />
      <center><BG /></center>
      <hr />
      <center><Forma /></center>
      <hr />
      <center><Formb /></center>
      <hr />
      <center><Formc /></center>
      <hr />
      <center><Formd /></center>
      <hr />
      <Todo />
      <hr />
      <center>
        <h1>Increment Decrement</h1>
        <Incdec />
      </center>
      <hr />
      <BasicTextFields />
      <hr />
      <UrgeWithPleasureComponent />
      <hr />
      <Clockc />
      <hr />
      <Todolistnew /> 
      <hr />
      <Accordiann />
      <hr />
      <Googlekeep />
      <hr />
      <Contexta />
      <hr />
      <Useeffecta />
      <hr />
      <Covida />
      <hr />
      <Pokemonapi />
      <hr />
      <Page />
      <hr />
      <Todo2 />
      <hr />
      <Todol />
    </div>
<div style={{height:"50px"}}></div>
  </>,
  document.getElementById("root")
);

// const alpha = ["Moobeen","Quader","Smuftech"]
// const beta = ["BMoobeen","BQuader","BSmuftech"]

// const gamma = [...alpha,"Testing"]

// console.log(gamma);

// const [first,...remaining] = alpha;

// console.log(first);